import FJPool from './FJPool';

class FJPoolCanvas extends FJPool {
    _clearItem(value) {
        value.width = 0;
        value.height = 0;
    }

    _createItem(options = { contextType: '2d', isOffscreen: false }) {
        const { contextType = '2d', isOffscreen = false } = options;

        const canvas =
            isOffscreen && typeof OffscreenCanvas !== 'undefined'
                ? new OffscreenCanvas(1, 1)
                : document.createElement('canvas');
        canvas.getContext(contextType);
        return { value: canvas, isOffscreen, idle: true };
    }

    _findIdleItem(options = { contextType: '2d', isOffscreen: false }) {
        const { contextType = '2d', isOffscreen = false } = options;
        return this._list.find(
            ({ idle, value, isOffscreen: offscreen }) =>
                idle && offscreen === isOffscreen && !!value.getContext(contextType),
        );
    }
}

export default FJPoolCanvas;
